import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Button, Row, Col, Drawer } from 'antd'
import { Controlled as CodeMirror } from 'react-codemirror2'

import './index.scss'

import {
  getBrandFunction,
  updateBrandFunctionsState,
  updateBrandFunction,
  getImportedFilesForBrandFunction
} from '../../../../../../data/redux/brand_function_details/actions'
import { pageChanged } from '../../../../../../data/redux/page_details/actions'

import { APP_PAGES, ROUTE_PATH, APP_LAYOUT } from '../../../../../../data/config/constants'
import { showMessage, log } from '../../../../../../data/config/utils'

import TextAreaItem from '../../../../../../components/form/textareaitem'
import SwitchItem from '../../../../../../components/form/switchitem'
import ErrorBoundary from '../../../../../../components/errorboundary'

class EditBrandFunction extends React.Component {
  state = {
    drawer_data: {
      title: '',
      show_imported_file: false
    }
  }

  componentDidMount() {
    const { actions, match, history } = this.props
    actions.pageChanged(APP_PAGES.EDIT_BRAND_FUNCTIONS, APP_PAGES.BOT_BUILDER)
    actions.getImportedFilesForBrandFunction()
    if (match && match.params && match.params.brandFunctionId)
      actions.getBrandFunction({ _id: match.params.brandFunctionId })
    else {
      history.push(ROUTE_PATH.BRAND_FUNCTIONS)
      showMessage('error', 'route params are not valid')
    }
  }

  componentWillUnmount() {
    const { actions } = this.props
    actions.updateBrandFunctionsState({ selected_bf: {}, file_imported: "" })
  }

  goToBrandFunctionsPage = () => {
    const { history } = this.props
    history.push(ROUTE_PATH.BRAND_FUNCTIONS)
  }

  handleOnChangeSelectedBf = event => {
    const { actions, selected_bf } = this.props
    const payload = {
      ...selected_bf,
      [event.target.name]: event.target.value
    }
    actions.updateBrandFunctionsState({ selected_bf: payload })
  }

  handleOnChangeSwitch = (bool, event) => {
    const { actions, selected_bf } = this.props
    const payload = {
      ...selected_bf,
      [event.target.name]: bool
    }
    actions.updateBrandFunctionsState({ selected_bf: payload })
  }

  handleOnChangeDefinition = (e, d, definition) => {
    log(e, d, definition)
    const { actions, selected_bf } = this.props
    const payload = {
      ...selected_bf,
      definition
    }
    actions.updateBrandFunctionsState({ selected_bf: payload })
  }

  updateBrandFunction = () => {
    const { actions, selected_bf } = this.props
    if (selected_bf._id)
      actions.updateBrandFunction(selected_bf, this.goToBrandFunctionsPage)
    else
      showMessage('error', '_id is missing in brand function')
  }

  showBrandFilesInDrawer = () => {
    this.setState({
      drawer_data: {
        title: 'Brand Files (read only)',
        show_imported_file: true
      }
    })
  }

  closeDrawer = () => {
    this.setState({
      drawer_data: {
        title: '',
        show_imported_file: false
      }
    })
  }

  render() {
    const { selected_bf, screen_height, screen_width, file_imported } = this.props
    const { drawer_data } = this.state
    return (
      <div className="ori-lr-pad-10 oriEditBrandFunction">
        <div className="ori-t-pad-15 ori-flex-row ori-flex-jsb ori-flex-wrap ori-b-border-default ori-b-mrgn-10">
          <p className="ori-b-mrgn-15 ori-font-md">Edit brand function</p>
          <div className="ori-b-mrgn-15 ori-flex-row">
            <Button
              size='small'
              type='default'
              className='ori-font-xs ori-r-mrgn-10 ori-lr-pad-10'
              onClick={this.goToBrandFunctionsPage}
            >
              Cancel
            </Button>
            <Button
              size='small'
              type='primary'
              className='ori-font-xs ori-lr-pad-15'
              onClick={this.updateBrandFunction}
            >
              Save
            </Button>
          </div>
        </div>
        <Row gutter={10}>
          <Col xs={24} md={12} className="ori-b-pad-10">
            <div
              className="ori-border-radius-3 ori-overflow-hidden"
              style={{
                height: `${screen_height - APP_LAYOUT.APP_HEADER_HEIGHT - 75}px`,
              }}
            >
              {
                selected_bf.definition !== undefined &&
                <CodeMirror
                  className="ori-full-parent-height ori-font-sm brandFunctionEditor"
                  options={{
                    mode: { name: "javascript", json: true },
                    lineNumbers: true,
                    lineWrapping: true,
                    tabSize: 2,
                  }}
                  value={selected_bf.definition}
                  onBeforeChange={this.handleOnChangeDefinition}
                />
              }
            </div>
          </Col>
          <Col xs={24} md={12} className="ori-b-pad-10">
            <div className="ori-bg-white ori-lr-pad-15 ori-t-pad-10 ori-b-pad-20 ori-border-radius-3">
              <div className="ori-b-pad-10 ori-flex-row ori-flex-jsb">
                <p className="ori-font-15 ori-t-pad-5">{selected_bf.name}</p>
                <SwitchItem
                  switch_first
                  title={selected_bf.isActive ? "Active" : "Inactive"}
                  name="isActive"
                  checked={selected_bf.isActive}
                  onChange={this.handleOnChangeSwitch}
                />
              </div>
              <TextAreaItem
                title="description"
                name="description"
                value={selected_bf.description}
                min_rows={5}
                max_rows={6}
                onChange={this.handleOnChangeSelectedBf}
              />
              <p className="ori-font-light ori-font-sm ori-tb-mrgn-15"> By clicking on below button, you can see the packages and files which are imported for this brand function. you can not directly edit this file here. you can only edit brand function definition.</p>
              <Button type='primary' onClick={this.showBrandFilesInDrawer}>Check Brand Files</Button>
            </div>
          </Col>
        </Row>
        <Drawer
          className="ori-drawer ori-drawer-body-with-header ori-drawer-body-no-pad"
          width={screen_width < 768 ? screen_width : 700}
          title={drawer_data.title}
          visible={drawer_data.show_imported_file}
          placement="right"
          maskClosable={false}
          onClose={this.closeDrawer}
        >
          <ErrorBoundary onErrorCallback={this.closeDrawer}>
            <CodeMirror
              className="ori-full-parent-height ori-font-xs brandFunctionEditor"
              options={{
                mode: { name: "javascript", json: true },
                lineNumbers: true,
                lineWrapping: true,
                readOnly: true,
                tabSize: 2,
              }}
              value={file_imported}
            />
          </ErrorBoundary>
        </Drawer>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    screen_height: state.page_details.device_data.screen_height,
    screen_width: state.page_details.device_data.screen_width,
    selected_bf: state.brand_functions_details.selected_bf,
    file_imported: state.brand_functions_details.file_imported,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      {
        pageChanged,
        getBrandFunction,
        updateBrandFunction,
        getImportedFilesForBrandFunction,
        updateBrandFunctionsState
      },
      dispatch
    )
  }
}

EditBrandFunction.propTypes = {
  selected_bf: PropTypes.object,
  screen_height: PropTypes.number,
  screen_width: PropTypes.number,
  file_imported: PropTypes.string,
  is_mobile: PropTypes.bool,
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object
}

EditBrandFunction.defaultProps = {
  is_mobile: false
}

export default connect(mapStateToProps, mapDispatchToProps)(EditBrandFunction)



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/brandfunctions/EditBrandFunction/index.js